import { render, staticRenderFns } from "./OxxoReceipt.vue?vue&type=template&id=6e4db64a&scoped=true&"
import script from "./OxxoReceipt.vue?vue&type=script&lang=js&"
export * from "./OxxoReceipt.vue?vue&type=script&lang=js&"
import style0 from "./OxxoReceipt.vue?vue&type=style&index=0&id=6e4db64a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4db64a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
